import * as React from 'react';

import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';

import { ContextStore } from 'bernie-core';

import { useLocalization, ILocalization } from '@shared-ui/localization-context';

import { Breadcrumbs } from '../shared/breadcrumbs';
import { PreviewBanner } from '../shared/preview-banner';

import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkBanner } from 'uitk-react-banner';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLink } from 'uitk-react-link';
import { UitkPrimaryButton } from 'uitk-react-button';

import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

import { ProgramStore, UserAuthStore } from 'stores';

import { Program } from 'models';

interface PageHeaderProps {
  context?: ContextStore;
  joinLink?: string;
  externalLink?: boolean;
  programStatus?: string;
  title?: string;
  crumbs?: any[];
  noBorder?: boolean;
}

export const PageHeader: React.FunctionComponent<PageHeaderProps> = inject('context')(
  ({ joinLink, context, programStatus, title, externalLink, crumbs, noBorder }) => {
    const l10n = useLocalization();

    const link = joinLink?.replace(':localeName', modifyLocaleParam(context.locale));

    const notJoined = programStatus === null || programStatus === 'UNKNOWN';

    return (
      <UitkSpacing margin={{ blockstart: 'six', blockend: 'six' }}>
        <header className="container">
          <Breadcrumbs crumbs={crumbs} />
          <UitkSpacing margin={{ blockend: 'four' }}>
            <UitkLayoutFlex alignItems="center" justifyContent="space-between" space="two">
              <UitkHeading tag="h1" size={2} className="PageHeader__title">
                {title}
              </UitkHeading>
              {notJoined && (
                <UitkLayoutFlexItem>
                  {externalLink ? (
                    <UitkPrimaryButton href={link} tag="a">
                      {l10n.formatText('preview.products.join.the.program')}
                    </UitkPrimaryButton>
                  ) : (
                    <Link to={link}>
                      <UitkPrimaryButton type={'button'}>
                        {l10n.formatText('preview.products.join.the.program')}
                      </UitkPrimaryButton>
                    </Link>
                  )}
                </UitkLayoutFlexItem>
              )}
            </UitkLayoutFlex>
          </UitkSpacing>
          {!noBorder && (
            <div className="ghosted">
              <UitkSpacingHr />
            </div>
          )}
          <>
            {notJoined && <PreviewBanner externalLink={externalLink} l10n={l10n} link={link} />}
            {programStatus && programStatus === 'PENDING' && (
              <UitkBanner icon="info_outline" message={l10n.formatText('products.pending.banner.text')} />
            )}
          </>
        </header>
      </UitkSpacing>
    );
  },
);
